<div *ngIf="!permissions.includes('access')" class="forbidden-access">
  <mat-icon svgIcon="forbidden"></mat-icon>
  <span class="access-txt">Accès non autorisé</span>

  <button mat-flat-button color="primary" (click)="logout()">Déconnexion</button>
</div>

<div *ngIf="permissions.includes('access' && 'import_files') && !errorInit" style="margin: 15px 0 0; text-align: center;">
  <mat-chip *ngIf="!errorInit && (!initFolder || !initConfig || !initProprietes || !initCategories || !initGenresAssociation || !initWinmedia)" style="background-color: #f39c12; color: #fff; margin: 15px auto 0; font-weight: bold">Statut initialisation</mat-chip>
  <mat-chip *ngIf="!errorInit && initFolder && initConfig && initProprietes && initCategories && initGenresAssociation && initWinmedia" style="background-color: #27ae60; color: #fff; margin: 15px auto 0; font-weight: bold">Statut initialisation</mat-chip>
  <mat-chip *ngIf="errorInit" style="background-color: #c0392b; color: #fff; margin: 15px auto 0; font-weight: bold">Statut initialisation</mat-chip>
</div>

<button *ngIf="permissions.includes('access' && 'import_files') && !errorInit" color="primary" mat-flat-button style="display: block; margin: 40px auto 0;" (click)="searchMusics()">Rechercher des musiques à importer</button>

<mat-tab-group #soundType mat-align-tabs="center" *ngIf="permissions.includes('access' && 'import_files' && 'import_sons')">
  <mat-tab label="Musiques"></mat-tab>
  <mat-tab label="Sons"></mat-tab>
</mat-tab-group>

<div *ngIf="permissions.includes('access' && 'import_files') && !errorInit">
  <div #myDrop class="dropzone dropzone-container"
       [dropzone]="config"
       (complete)="dropzoneOnUploadComplete($event)" (queueComplete)="dropzoneOnUploadQueuecomplete($event)" (sending)="dropzoneOnSending()"
       (removedFile)="removeFile($event)"></div>
  <button class="dropzone-button" (click)="sendFiles()" [disabled]="!allUploaded" color="primary" mat-flat-button>Envoyer</button>
</div>

<!--<app-historic *ngIf="(permissions.includes('access' && 'view_historic') || permissions.includes('access' && 'view_all_historic')) && !errorInit"></app-historic>-->
